import React, { ReactElement, useEffect, useRef } from 'react';
import { Element } from 'react-scroll/modules';
import dynamic from 'next/dynamic';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { aiStateType } from '@domain/rs/ai/AiTrialResultRs';
import { ClassNameData, OnScrollClassName } from '@utils/hooks/useScrollInteraction/data/classData';
import classnames from 'classnames/bind';
import styles from './tutorial.module.scss';
const ReactPlayer = dynamic(() => import('react-player') as any, { ssr: false }) as any;

const cx = classnames.bind(styles);

const buttonText = (state: aiStateType | undefined) => {
  switch (state) {
    case 'READY':
    case 'CHEER_UP':
    case 'FAIL':
      return '시작하기';
    case 'ING':
      return '이어하기';
    case 'GOOD':
    case 'PERFECT':
    case 'PASS':
      return '다시하기';
    default:
      return '시작하기';
  }
};

const buttonState = (state: aiStateType | undefined) => {
  switch (state) {
    case 'ING':
    case 'GOOD':
    case 'PERFECT':
    case 'PASS':
      return 'type1';
    default:
      return '';
  }
};

interface TutorialSectionProps {
  id: string;
  title: string;
  dec: ReactElement;
  time: string;
  noticeList: Array<string>;
  url: string;
  openLoginModal: () => void;
  state?: aiStateType;
  type: string;
  videoUrl: string;
  onScrollClassName: OnScrollClassName;
}

const TutorialSection = ({
  id,
  title,
  dec,
  time,
  noticeList,
  url,
  openLoginModal,
  state,
  type,
  videoUrl,
  onScrollClassName,
}: TutorialSectionProps) => {
  const { data } = useUserInfo();
  const isLogin = !!data?.id;
  const player = useRef<any>(null);
  const sectionEl = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const classNameData: ClassNameData = {
      baseLineEl: sectionEl.current,
      top: () => -window.innerHeight + 500,
      bottom: () => -window.innerHeight + 3000,
      className: cx('on'),
    };

    onScrollClassName({ el: sectionEl.current, classNameData });
  }, []);

  const noticeListEl = noticeList.map((notice: string, index: number) => {
    return (
      <li key={index} className={cx('listItem')}>
        {notice}
      </li>
    );
  });

  const handleClick = () => {
    if (!isLogin) openLoginModal();
    else window.open(`/acc/experience/${url}`);
  };

  return (
    <Element name={id}>
      <div ref={sectionEl} className={cx('section', type)} id={id}>
        <div className={cx('sectionInner')}>
          <div className={cx('infoArea')}>
            <span className={cx('text')}>{title}</span>
            <p className={cx('desc')}>{dec}</p>
            <div className={cx('time')}>
              <span className={cx('timeText')}>소요시간</span>
              <span className={cx('timeText')}>{time}분</span>
            </div>
            <ul className={cx('noticeList')}>{noticeListEl}</ul>
            <a onClick={handleClick} className={cx('btnStart', buttonState(state))} role="button">
              {buttonText(state)}
            </a>
          </div>
          <div className={cx('videoWrap')}>
            <ReactPlayer
              ref={player}
              url={`/video/acc/tutorial/${videoUrl}`}
              playing={true}
              muted={true}
              loop={true}
              width={'100%'}
              height={'100%'}
            />
          </div>
        </div>
      </div>
    </Element>
  );
};

export default TutorialSection;
